import AOClpSlider from '../helpers/slider';

export default function AOClpHighlightsColumns(sliders) {
  const initiate = () => {
    const clpSlider = AOClpSlider(sliders);
    clpSlider.initiate();
  };

  return { initiate };
}
